module.exports = __webpack_public_path__ + "static/media/logo-tagline.a63e1c2d.png";